import { 
  initializeFAQCategories, 
  createFAQ, 
  getFAQCategories 
} from '../services/faqService';
import { Timestamp } from 'firebase/firestore';

export const initializeDefaultFAQs = async (adminUserId: string) => {
  try {
    console.log('🚀 Inizializzazione FAQ di default...');
    
    // Prima inizializza le categorie
    await initializeFAQCategories();
    console.log('✅ Categorie inizializzate');
    
    // Ottieni le categorie per avere gli ID corretti
    const categories = await getFAQCategories();
    console.log('📋 Categorie caricate:', categories.length);
    console.log('📋 Categorie:', categories.map(c => ({ id: c.id, name: c.name })));
    
    // Mappa dei nomi delle categorie agli ID
    const categoryMap = {
      'Generale': categories.find(c => c.name === 'Generale')?.id || 'general',
      'Candidature': categories.find(c => c.name === 'Candidature')?.id || 'applications',
      'Colloqui': categories.find(c => c.name === 'Colloqui')?.id || 'interviews',
      'Moderatori': categories.find(c => c.name === 'Moderatori')?.id || 'moderator',
      'Amministrazione': categories.find(c => c.name === 'Amministrazione')?.id || 'admin'
    };
    
    console.log('🗺️ Mappa categorie:', categoryMap);
    
    // FAQ di default
    const defaultFAQs = [
      {
        question: 'Come funziona la piattaforma QUO VADIS?',
        answer: 'QUO VADIS è una piattaforma per tracciare le tue candidature di lavoro. Puoi aggiungere candidature, gestire colloqui, monitorare stati e tenere traccia di tutti i tuoi contatti con le aziende. La piattaforma ti aiuta a organizzare la tua ricerca di lavoro in modo professionale.',
        category: categoryMap['Generale'],
        order: 1,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come aggiungere una nuova candidatura?',
        answer: 'Per aggiungere una candidatura, vai alla sezione "Candidature" e clicca su "Nuova Candidatura". Compila il form con i dettagli dell\'azienda, posizione, metodo di contatto e altre informazioni. Puoi anche allegare documenti come CV e lettere di presentazione.',
        category: categoryMap['Candidature'],
        order: 1,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come modificare lo stato di una candidatura?',
        answer: 'Apri la candidatura dalla lista e clicca su "Aggiorna Stato". Puoi scegliere tra: In attesa, Colloquio programmato, Accettato, Rifiutato, Scaduto. Ogni cambio di stato viene registrato con timestamp e note opzionali.',
        category: categoryMap['Candidature'],
        order: 2,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come programmare un colloquio?',
        answer: 'Vai alla sezione "Colloqui" e clicca sul pulsante "+" per aggiungere un nuovo appuntamento. Seleziona la candidatura correlata, inserisci data, ora, tipo di colloquio (presenza, online, telefono) e dettagli aggiuntivi. Puoi anche impostare reminder automatici.',
        category: categoryMap['Colloqui'],
        order: 1,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come gestire i documenti allegati?',
        answer: 'Durante la creazione o modifica di una candidatura, puoi allegare documenti nella sezione "Allegati". Supportiamo file PDF, Word e immagini. I documenti vengono salvati in modo sicuro e sono accessibili solo a te.',
        category: categoryMap['Candidature'],
        order: 3,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come modificare il mio profilo utente?',
        answer: 'Vai alle "Impostazioni" e poi alla sezione "Account". Qui puoi modificare il tuo nome, email e altre informazioni del profilo. Le modifiche vengono salvate automaticamente.',
        category: categoryMap['Generale'],
        order: 2,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come funziona il sistema di notifiche?',
        answer: 'La piattaforma ti invia notifiche per: reminder di colloqui, candidature senza risposta da più di 7 giorni, e aggiornamenti importanti. Puoi gestire le notifiche nelle impostazioni.',
        category: categoryMap['Generale'],
        order: 3,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come contattare le aziende (Moderatori)?',
        answer: 'Come moderatore, puoi vedere tutte le candidature degli utenti nella sezione "Gestione Candidature". Puoi contattare le aziende e registrare i tuoi contatti nella sezione "I Miei Contatti". Ogni contatto viene tracciato con dettagli completi.',
        category: categoryMap['Moderatori'],
        order: 1,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come generare report settimanali (Moderatori)?',
        answer: 'Nella dashboard moderatore, clicca su "Report Settimanale" per generare un PDF con tutti i contatti effettuati nella settimana. Il report include statistiche e dettagli delle risposte ricevute.',
        category: categoryMap['Moderatori'],
        order: 2,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      },
      {
        question: 'Come gestire gli utenti (Amministratori)?',
        answer: 'Gli amministratori possono vedere tutti gli utenti registrati, modificare i loro ruoli (utente, moderatore, admin) e monitorare l\'attività della piattaforma. Accedi alla sezione "Gestione Utenti" per queste funzionalità.',
        category: categoryMap['Amministrazione'],
        order: 1,
        isActive: true,
        createdBy: adminUserId,
        updatedBy: adminUserId
      }
    ];
    
    // Crea le FAQ
    for (const faq of defaultFAQs) {
      console.log(`📝 Creazione FAQ: ${faq.question.substring(0, 50)}... (categoria: ${faq.category})`);
      await createFAQ(faq);
      console.log(`✅ FAQ creata: ${faq.question.substring(0, 50)}...`);
    }
    
    console.log('🎉 Inizializzazione FAQ completata con successo!');
    return true;
    
  } catch (error) {
    console.error('❌ Errore durante l\'inizializzazione FAQ:', error);
    throw error;
  }
}; 